import {
  getPluginOptions,
  sanitizeUrl,
  ELEMENT_LINK,
} from '@udecode/plate';

export const validateUrl = (
  editor,
  url,
) => {
  const { allowedSchemes, isUrl } = getPluginOptions(
    editor,
    ELEMENT_LINK,
  );

  if (isUrl && !isUrl(url)) return false;

  if (
    !sanitizeUrl(url, {
      allowedSchemes,
      permitInvalid: true,
    })
  )
    return false;

  return true;
};
